function updateQuantitiesFromBasket () {
  fetch('/basket/quantities.json')
    .then(response => response.json())
    .then(data => fillQuantities(data))
}

function fillQuantities (basketQuantities) {
  const productQuantitySelector = '.add-to-basket-form .qty-input[data-product-id]'

  document.querySelectorAll(productQuantitySelector).forEach(function (qty) {
    qty.dataset.filled = ''
    // Clear all quantities to start with in case an item has been removed from the basket.
    qty.value = ''
  })

  document.querySelectorAll(productQuantitySelector).forEach(function (qty) {
    const productId = qty.dataset.productId
    for (let i = 0; i < basketQuantities.length; i++) {
      const bq = basketQuantities[i]
      if (bq.product_id.toString() === productId) {
        // Check the data-filled property as we only want to set a quantity box
        // once.
        if (qty.dataset.filled !== '1') {
          qty.value = bq.quantity
        }
      }
    }
    // We've filled, or at least considered filling, this quantity box so mark
    // it as such so we skip it in future.
    qty.dataset.filled = '1'
  })

  // Add a marker in the DOM for system testing to prevent race conditions by marking
  // when this action is complete.
  const markerClass = 'quantitiesUpdatedFromBasket'
  if (!document.querySelector('.' + markerClass)) {
    const marker = document.createElement('span')
    marker.className = markerClass
    document.querySelector('html').append(marker)
  }
}

function prepareBasketPage () {
  const sendBasket = document.querySelector('.sendBasket')
  if (sendBasket) {
    sendBasket.classList.remove('sendBasket-active')
  }

  const emailQuoteLink = document.querySelector('.email_quote_link')
  if (emailQuoteLink) {
    emailQuoteLink.addEventListener('click', function (e) {
      e.preventDefault()
      const sendBasket = document.querySelector('.sendBasket')
      if (sendBasket) {
        sendBasket.classList.toggle('sendBasket-active')
      }
    })
  }
}

(function preventInputTypeNumberScrolling () {
  document.addEventListener('wheel', function() {
    if(document.activeElement.type === 'number') {
      document.activeElement.blur()
    }
  })
})()

export { updateQuantitiesFromBasket, prepareBasketPage }
